// extracted by mini-css-extract-plugin
module.exports = {"moduleRoot":"MainNavigation_moduleRoot__2fAOF","listItem":"MainNavigation_listItem__zzD2q","navLink":"MainNavigation_navLink___KlpU","current":"MainNavigation_current__2_lD5"};